var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path !== '/login')?_c('MenuBar',{class:{ 
      'text-white': _vm.$route.path === '/', 
      'mistake': _vm.$route.path !== '/' 
    }}):_vm._e(),_c('router-view'),(_vm.$route.path !== '/login')?_c('FloatingActions',{attrs:{"SpgData":_vm.SpgData}}):_vm._e(),(_vm.$route.path !== '/login')?_c('FooterBar',{attrs:{"SpgData":_vm.SpgData,"QRcode":_vm.SpgData.QRcode,"adminLogin":_vm.SpgData.adminLogin}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }